module.exports = __webpack_public_path__ + "img/10551386_L.c4cd1406.png";